import { getRandomAlphaNumString } from '@jfs/utils'
import { dateToLocaleISO } from '../../util/util'

//TODO: change returnUrl and emails
// commented non mandatory fields and updated returnUrl as per Pritam1.patel

export const createIntentRequestBody = (amount: string, mid: string, merchantName: string) => {
  const body = {
    transaction: {
      idempotentKey: getRandomAlphaNumString(32),
      currency: 356,
      invoice: getRandomAlphaNumString(10),
      method: { type: 300 },
      mode: 1,
      livemode: 'true',
      application: 8006,
      initiatingEntityTimestamp: dateToLocaleISO(new Date()),
      initiatingEntity: {
        entityId: 2103,
        callbackUrl: 'http://psp-mandate-merchant-sit.jiomoney.com:3003/merchantsimulator/sit/merchantstatus',
        returnUrl: 'http://psp-mandate-merchant-sit.jiomoney.com:3003/pg/transaction/details',
        // returnUrl: 'http://psp-mandate-merchant-sit.jiomoney.com:3003/merchantsimulator/sit/merchantstatus',
      },
    },
    amount: { netAmount: amount, grossAmount: amount },
    // payer: {
    //   userId: '',
    //   externalId: 'test123',
    //   type: 11,
    //   name: '',
    //   email: '',
    //   mobile: { number: null, countryCode: '91' },
    // },
    // payee: { merchantId: mid, type: 12, name: merchantName, email: 'dabralnavneet@gmail.com' },
    payee: { merchantId: mid, type: 12, name: merchantName },
  }
  return body
}
